<template>
  <v-app-bar app>
    <v-menu
      v-if="
        isMobile &&
        ![`/${currentLang}`, `/${currentLang}/`].includes($route.path)
      "
      left
      bottom
    >
      <template #activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          @click="gotoMenu(item.link)"
          style="text-transform: uppercase !important"
        >
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      elevation="0"
      @click="gotoMenu('')"
      :style="innerWidth > 750 ? '' : 'padding: 0px !important'"
    >
      <v-img
        :src="
          isDarkMode ? '/img/logo/logo_white.png' : '/img/logo/Logo_black.png'
        "
        class="icon-menu"
        :height="innerWidth > 750 ? 40 : 27"
        :min-width="innerWidth > 750 ? 235 : 157"
      ></v-img>
    </v-btn>

    <v-spacer></v-spacer>

    <!-- เมนู Desktop (แสดงเฉพาะบนจอใหญ่) -->
    <div
      v-if="![`/${currentLang}`, `/${currentLang}/`].includes($route.path)"
      class="d-none d-md-flex"
      style="column-gap: 4px"
    >
      <v-btn
        v-for="(item, index) in menuItems"
        :key="index"
        :class="
          $route.path.includes(item.link)
            ? 'mr-2 btn-custom-upper primary white--text'
            : 'mr-2'
        "
        @click="gotoMenu(item.link)"
        height="42px"
        depressed
        rounded
      >
        {{ $t(item.title) }}
      </v-btn>
    </div>

    <v-spacer></v-spacer>

    <!-- Group - Dropdown ภาษา, Dark/Light Mode, Account -->
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
          :style="innerWidth > 750 ? '' : 'padding: 0px !important'"
        >
          <img
            :src="
              currentLang === 'th' ? '/img/lang/th.png' : '/img/lang/eng.png'
            "
            style="width: 20px"
            class="mr-2"
          />
          {{ currentLang }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="lang in languages"
          :key="lang.value"
          @click="setLanguage(lang.value)"
        >
          <v-list-item-avatar size="25">
            <v-img :src="lang.img"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>{{ lang.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn icon @click="toggleTheme">
      <v-icon>{{
        isDarkMode ? 'mdi-weather-night' : 'mdi-white-balance-sunny'
      }}</v-icon>
    </v-btn>

    <template>
      <v-menu offset-y left :close-on-content-click="false" ref="menuRef">
        <!-- Activator: avatar button -->
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <template
              v-if="
                profile.account &&
                profile.account.member_account &&
                profile.account.member_account.picture_url
              "
            >
              <v-img
                :src="profile.account.member_account.picture_url"
                width="32"
                height="32"
                class="rounded-circle"
                style="margin: 8px"
              />
            </template>
            <template v-else>
              <v-icon>mdi-account-circle</v-icon>
            </template>
          </v-btn>
        </template>

        <!-- Popover content -->
        <v-card min-width="320" class="popover-card">
          <!-- Top section -->
          <v-card-title class="pa-4 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <template
                v-if="
                  profile.account &&
                  profile.account.member_account &&
                  profile.account.member_account.picture_url
                "
              >
                <v-img
                  :src="profile.account.member_account.picture_url"
                  width="48"
                  height="48"
                  class="rounded-circle"
                  style="margin: 8px"
                />
              </template>
              <template v-else>
                <v-icon>mdi-account-circle</v-icon>
              </template>
              <div class="font-weight-bold ml-2">
                {{ profile.fullName }}
              </div>
            </div>
            <v-btn icon style="margin-left: auto" @click="howto()">
              <v-icon>mdi-dots-grid</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Account Info -->

          <validation-observer ref="updateAccountForm" v-slot="{ invalid }">
            <form @submit.prevent="updateAccount">
              <v-card-text>
                <div class="font-weight-bold mb-2 d-flex">
                  {{ $t('account') }}
                  <v-spacer></v-spacer>
                  <template v-if="!profile.isEdit">
                    <v-btn icon small @click="clickEditAccount()">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </div>
                <div class="d-flex align-baseline mb-1">
                  <v-icon left class="mr-2">mdi-email</v-icon>
                  {{ profile.account ? profile.account.email : '' }}
                </div>
                <div class="d-flex align-baseline mb-1">
                  <v-icon left class="mr-2">mdi-account</v-icon>
                  <template v-if="!profile.isEdit">
                    {{ profile.fullName }}
                  </template>
                  <template v-else>
                    <validation-provider
                      v-slot="{ errors }"
                      name="First name"
                      rules="required"
                      class="mr-2"
                    >
                      <v-text-field
                        v-model="profileForm.first_name"
                        dense
                        outlined
                        :disabled="!profile.isEdit"
                        :error-messages="errors"
                      />
                    </validation-provider>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Last name"
                      rules="required"
                    >
                      <v-text-field
                        v-model="profileForm.last_name"
                        dense
                        outlined
                        :disabled="!profile.isEdit"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </template>
                </div>
                <div class="d-flex align-baseline mb-1">
                  <v-icon left class="mr-2">mdi-phone</v-icon>
                  <template v-if="!profile.isEdit">
                    {{
                      profile.account
                        ? profile.account.member_account.telephone_no
                        : ''
                    }}
                  </template>
                  <template v-else>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Telephone number"
                    >
                      <v-text-field
                        v-model="profileForm.telephone_no"
                        dense
                        outlined
                        :disabled="!profile.isEdit"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </template>
                </div>

                <div class="mt-3">
                  {{ $t('connect_account') }}
                </div>
                <div class="d-flex align-center mb-2">
                  <img
                    src="https://i.pinimg.com/564x/70/da/29/70da29e0cd3e98f2ba4bb67bd0bde726.jpg"
                    alt="Facebook"
                    width="20"
                    height="20"
                    class="mr-2"
                    :style="{
                      borderRadius: '20px',
                      filter: `grayscale(${profile.facebookAccount ? 0 : 1})`
                    }"
                  />
                  <span>
                    {{
                      profile.facebookAccount
                        ? profile.facebookAccount.name
                        : ''
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    :outlined="!!profile.facebookAccount"
                    color="primary"
                    @click="
                      profile.facebookAccount
                        ? disconnectFacebook()
                        : syncFaceBookAccount()
                    "
                  >
                    {{
                      profile.facebookAccount ? $t('disconnect') : $t('connect')
                    }}
                  </v-btn>
                </div>
                <div class="d-flex align-center">
                  <img
                    src="https://i.pinimg.com/564x/4d/3a/97/4d3a972606de69f3cdaa88ca7163d0ed.jpg"
                    alt="Line"
                    width="20"
                    height="20"
                    class="mr-2"
                    :style="{
                      borderRadius: '20px',
                      filter: `grayscale(${profile.lineAccount ? 0 : 1})`
                    }"
                  />
                  {{ profile.lineAccount ? profile.lineAccount.name : '' }}
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    :outlined="!!profile.lineAccount"
                    color="primary"
                    @click="
                      profile.lineAccount ? disconnectLine() : syncLineAccount()
                    "
                  >
                    {{ profile.lineAccount ? $t('disconnect') : $t('connect') }}
                  </v-btn>
                </div>
              </v-card-text>

              <v-card-actions>
                <div class="mx-auto mb-1">
                  <template v-if="!profile.isEdit">
                    <v-dialog v-model="dialog" persistent max-width="800px">
                      <template #activator="{ on, attrs }">
                        <v-btn small color="primary" v-bind="attrs" v-on="on">
                          {{ $t('contact_us') }}
                        </v-btn>
                      </template>
                      <v-card style="padding-bottom: 20px">
                        <div
                          class="pointer"
                          style="
                            float: right;
                            margin-right: 10px;
                            margin-top: 10px;
                          "
                        >
                          <v-icon @click="dialog = false">mdi-close</v-icon>
                        </div>
                        <v-card-title
                          v-if="dialog"
                          style="place-content: center; display: block"
                        >
                          <contact-us-form
                            v-model="profile.account"
                            @closeDialog="closeDialog"
                          />
                        </v-card-title>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-else>
                    <v-btn
                      small
                      color="primary"
                      outlined
                      class="mr-2"
                      @click="profile.isEdit = !profile.isEdit"
                    >
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      small
                      color="primary"
                      :disabled="invalid"
                      type="submit"
                    >
                      {{ $t('save') }}
                    </v-btn>
                  </template>
                </div>
              </v-card-actions>
            </form>
          </validation-observer>
        </v-card>
      </v-menu>
    </template>
  </v-app-bar>
</template>

<script>
import config from '@/config'
import cookieService from '@/services/cookieService'
import ContactUsForm from '../support/ContactUsForm.vue'

export default {
  components: { ContactUsForm },
  data() {
    return {
      innerWidth: 0,
      dialog: false,
      profile: {
        account: null,
        fullName: null,
        facebookAccount: null,
        lineAccount: null,
        isEdit: false
      },
      profileForm: {
        first_name: '',
        last_name: '',
        telephone_no: ''
      },
      menuItems: [
        { title: 'home', link: 'home' },
        { title: 'richmenu', link: 'richmenu' },
        { title: 'manage_channel', link: 'channel' },
        { title: 'setting', link: 'setting' }
      ],
      languages: [
        {
          value: 'th',
          text: 'TH',
          img: '/img/lang/th.png'
        },
        {
          value: 'en',
          text: 'EN',
          img: '/img/lang/eng.png'
        }
      ]
    }
  },
  created() {
    this.innerWidth = window.innerWidth
  },
  async mounted() {
    this.$vuetify.theme.dark = cookieService.getCookie('theme') === 'dark'
    // this.$i18n.locale = cookieService.getCookie('language') || 'th' //Default from url
    this.getAccount()
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      cookieService.setCookie(
        'theme',
        this.$vuetify.theme.dark ? 'dark' : 'light'
      )
    },
    setLanguage(lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang
        cookieService.setCookie('language', lang)
        this.$router.push({
          path: `/${lang}${this.$route.fullPath.substring(3)}`
        })
      }
    },
    gotoMenu(link) {
      if (link === '') {
        sessionStorage.setItem('preventAutoSelectBusiness', true)
      }
      const path = `/${this.currentLang}/${link}`
      if (this.$route.path !== path) {
        this.$router.push({ path })
      }
    },
    async getAccount() {
      this.$store.dispatch('setOverlay', true)
      var res = await this.$store.dispatch('ssoAccount/getAccount')
      if (res && res.data && res.data.result) {
        this.$store.dispatch('setOverlay', false)
        this.profile.account = res.data.result
        if (this.profile.account) {
          const memberAccount = this.profile.account.member_account
          if (memberAccount.first_name) {
            this.profile.fullName = memberAccount.first_name + ' '
          }
          if (memberAccount.last_name) {
            this.profile.fullName += memberAccount.last_name
          }
          if (this.profile.account.member_login_data_external) {
            this.profile.facebookAccount =
              this.profile.account.member_login_data_external.find(
                (ex) => ex.external_provider.id === 2
              )
            this.profile.lineAccount =
              this.profile.account.member_login_data_external.find(
                (ex) => ex.external_provider.id === 1
              )
          }
        }
      } else {
        if (res.message.includes('status code 401')) {
          this.$store.dispatch('login/setIsAuthenticated', 'false')
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `Something went wrong.`
          })
        }
        this.$store.dispatch('setOverlay', false)
      }
    },
    async updateAccount() {
      this.$store.dispatch('setOverlay', true)
      if (this.profile.isEdit) {
        let res = await this.$store.dispatch('ssoAccount/patchAccount', {
          member_account: this.profileForm
        })
        if (res) {
          this.$store.dispatch('setOverlay', false)
          const account = this.profile.account.member_account
          this.profileForm = {
            first_name: account.first_name || '',
            last_name: account.last_name || '',
            telephone_no: account.telephone_no || ''
          }
          await this.getAccount()
          this.profile.isEdit = false
          this.$nextTick(() => this.$refs.updateAccountForm.reset())
        } else {
          this.$store.dispatch('setOverlay', false)
          this.profile.isEdit = false
        }
      }
    },
    clickEditAccount() {
      this.profile.isEdit = true
      const account = this.profile.account.member_account
      this.profileForm = {
        first_name: account.first_name || '',
        last_name: account.last_name || '',
        telephone_no: account.telephone_no || ''
      }
    },
    howto() {
      window.open(`https://zwiz.app/${this.currentLang}/account`, '_blank')
    },
    syncFaceBookAccount() {
      window.open(
        `https://www.facebook.com/v23.0/dialog/oauth?client_id=1150606743564093&display=page&redirect_uri=${
          config.serverSSOUrl
        }/api/member/sync-facebook?state=${cookieService.getCookie(
          'user_token'
        )}&response_type=token&scope=email,public_profile&lang=${
          this.currentLang
        }`,
        '_self'
      )
    },
    syncLineAccount() {
      window.open(
        `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656125305&redirect_uri=${
          config.serverSSOUrl
        }/api/member/sync-line&state=${cookieService.getCookie(
          'user_token'
        )}&scope=profile%20openid%20email&lang=${this.currentLang}`,
        '_self'
      )
    },
    async disconnectFacebook() {
      this.$confirm(
        this.$t('confirm_disconnect_sync_facebook'),
        '',
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      ).then(async () => {
        this.$store.dispatch('setOverlay', true)
        var res = await this.$store.dispatch('ssoAccount/revokeFacebook')
        if (res) {
          this.$store.dispatch('setOverlay', false)
          this.profile.facebookAccount = null
        } else {
          this.$store.dispatch('setOverlay', false)
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `Something went wrong.`
          })
        }
      })
    },
    async disconnectLine() {
      this.$confirm(this.$t('confirm_disconnect_sync_line'), '', 'question', {
        reverseButtons: true,
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(async () => {
        this.$store.dispatch('setOverlay', true)
        var res = await this.$store.dispatch('ssoAccount/revokeLine')
        if (res) {
          this.$store.dispatch('setOverlay', false)
          this.profile.lineAccount = null
        } else {
          this.$store.dispatch('setOverlay', false)
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `Something went wrong.`
          })
        }
      })
    },
    closeDialog() {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.icon-menu {
  max-width: 100px;
  max-height: 100px;
}

.popover-card {
  overflow: visible;
  filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.32));
  margin-top: 8px;
  position: relative;
}

.popover-card::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 18px;
  width: 10px;
  height: 10px;
  background-color: var(--v-surface-base);
  transform: translateY(-50%) rotate(45deg);
  z-index: 0;
}

@media screen and (min-width: 1024px) {
  .icon-menu {
    max-width: 70px;
    max-height: 70px;
  }
}
</style>
